var map = {
	"./Afghanistan.png": 12202,
	"./Albania.png": 99312,
	"./Algeria.png": 98885,
	"./American_Samoa.png": 9668,
	"./Andorra.png": 91511,
	"./Angola.png": 16912,
	"./Anguilla.png": 75941,
	"./Antigua_and_Barbuda.png": 87887,
	"./Argentina.png": 94815,
	"./Armenia.png": 54097,
	"./Aruba.png": 96365,
	"./Australia.png": 71134,
	"./Austria.png": 30225,
	"./Azerbaijan.png": 14869,
	"./Bahamas.png": 571,
	"./Bahrain.png": 20479,
	"./Bangladesh.png": 92369,
	"./Barbados.png": 33580,
	"./Belarus.png": 80152,
	"./Belgium.png": 65751,
	"./Belize.png": 24939,
	"./Benin.png": 16310,
	"./Bermuda.png": 62136,
	"./Bhutan.png": 34506,
	"./Bolivia.png": 74588,
	"./Bonaire.png": 5776,
	"./Bosnia.png": 76918,
	"./Botswana.png": 47419,
	"./Brazil.png": 71380,
	"./British_Indian_Ocean_Territory.png": 59735,
	"./British_Virgin_Islands.png": 38182,
	"./Brunei.png": 26429,
	"./Bulgaria.png": 40477,
	"./Burkina_Faso.png": 98268,
	"./Burundi.png": 61643,
	"./Cambodia.png": 30208,
	"./Cameroon.png": 89530,
	"./Canada.png": 48444,
	"./Cape_Verde.png": 92428,
	"./Cayman_Islands.png": 74218,
	"./Central_African_Republic.png": 58359,
	"./Chad.png": 97616,
	"./Chile.png": 50303,
	"./China.png": 27169,
	"./Christmas_Island.png": 40870,
	"./Colombia.png": 57208,
	"./Comoros.png": 46874,
	"./Cook_Islands.png": 86833,
	"./Costa_Rica.png": 16334,
	"./Croatia.png": 74963,
	"./Cuba.png": 18817,
	"./Curacao.png": 1542,
	"./Cyprus.png": 5320,
	"./Czech_Republic.png": 27594,
	"./Côte_d'Ivoire.png": 69298,
	"./Democratic_Republic_of_the_Congo.png": 35837,
	"./Denmark.png": 40526,
	"./Djibouti.png": 11592,
	"./Dominica.png": 90784,
	"./Dominican_Republic.png": 54345,
	"./Ecuador.png": 70525,
	"./Egypt.png": 41621,
	"./El_Salvador.png": 95264,
	"./England.png": 51487,
	"./Equatorial_Guinea.png": 94657,
	"./Eritrea.png": 53334,
	"./Estonia.png": 28717,
	"./Ethiopia.png": 88063,
	"./Falkland_Islands.png": 62430,
	"./Faroe_Islands.png": 3400,
	"./Fiji.png": 78846,
	"./Finland.png": 29284,
	"./France.png": 24535,
	"./French_Guiana.png": 22610,
	"./French_Polynesia.png": 60197,
	"./Gabon.png": 99145,
	"./Gambia.png": 2433,
	"./Georgia.png": 56484,
	"./Germany.png": 51435,
	"./Ghana.png": 10077,
	"./Gibraltar.png": 6548,
	"./Greece.png": 31459,
	"./Greenland.png": 52550,
	"./Grenada.png": 64698,
	"./Guadeloupe.png": 57783,
	"./Guam.png": 15452,
	"./Guatemala.png": 32111,
	"./Guinea.png": 58337,
	"./Guinea_Bissau.png": 90225,
	"./Guyana.png": 86807,
	"./Haiti.png": 70867,
	"./Honduras.png": 71398,
	"./Hong_Kong.png": 41942,
	"./Hungary.png": 79594,
	"./Iceland.png": 76210,
	"./India.png": 2169,
	"./Indonesia.png": 19646,
	"./Iran.png": 19438,
	"./Iraq.png": 85609,
	"./Ireland.png": 67149,
	"./Israel.png": 71934,
	"./Italy.png": 97661,
	"./Jamaica.png": 28926,
	"./Japan.png": 64048,
	"./Jordan.png": 52032,
	"./Kazakhstan.png": 71584,
	"./Kenya.png": 9176,
	"./Kiribati.png": 85903,
	"./Kuwait.png": 89261,
	"./Kyrgyzstan.png": 53458,
	"./Laos.png": 64773,
	"./Latvia.png": 54711,
	"./Lebanon.png": 72411,
	"./Lesotho.png": 64710,
	"./Liberia.png": 92674,
	"./Libya.png": 13791,
	"./Liechtenstein.png": 27035,
	"./Lithuania.png": 7161,
	"./Luxembourg.png": 25706,
	"./Macao.png": 34045,
	"./Macedonia.png": 19671,
	"./Madagascar.png": 20334,
	"./Malawi.png": 63345,
	"./Malaysia.png": 43451,
	"./Maldives.png": 92833,
	"./Mali.png": 44361,
	"./Malta.png": 7615,
	"./Marshall_Islands.png": 89443,
	"./Martinique.png": 17727,
	"./Mauritania.png": 27409,
	"./Mauritius.png": 42313,
	"./Mexico.png": 2523,
	"./Micronesia.png": 56518,
	"./Moldova.png": 60980,
	"./Monaco.png": 26615,
	"./Mongolia.png": 50204,
	"./Montserrat.png": 89215,
	"./Morocco.png": 37766,
	"./Mozambique.png": 60340,
	"./Myanmar.png": 38081,
	"./Namibia.png": 33759,
	"./Nauru.png": 85495,
	"./Nepal.png": 42698,
	"./Netherlands.png": 10936,
	"./Netherlands_Antilles.png": 33689,
	"./New_Zealand.png": 60852,
	"./Nicaragua.png": 52273,
	"./Niger.png": 26339,
	"./Nigeria.png": 24985,
	"./Niue.png": 26495,
	"./Norfolk_Island.png": 65931,
	"./North_Korea.png": 69354,
	"./Norway.png": 19624,
	"./Oman.png": 58375,
	"./Pakistan.png": 60075,
	"./Palau.png": 94309,
	"./Panama.png": 68594,
	"./Papua_New_Guinea.png": 56776,
	"./Paraguay.png": 14710,
	"./Peru.png": 72984,
	"./Philippines.png": 89557,
	"./Pitcairn_Islands.png": 22077,
	"./Poland.png": 60966,
	"./Portugal.png": 69212,
	"./Puerto_Rico.png": 20415,
	"./Qatar.png": 14355,
	"./Republic_of_the_Congo.png": 81583,
	"./Romania.png": 88317,
	"./Russian_Federation.png": 80235,
	"./Rwanda.png": 51563,
	"./Saint_Kitts_and_Nevis.png": 12657,
	"./Saint_Lucia.png": 81012,
	"./Saint_Pierre.png": 95115,
	"./Saint_Vicent_and_the_Grenadines.png": 18520,
	"./Samoa.png": 4825,
	"./San_Marino.png": 39535,
	"./Sao_Tomé_and_Príncipe.png": 90458,
	"./Saudi_Arabia.png": 26387,
	"./Senegal.png": 6257,
	"./Serbia.png": 60124,
	"./Serbia_and_Montenegro.png": 82861,
	"./Seychelles.png": 96903,
	"./Sierra_Leone.png": 44614,
	"./Singapore.png": 37106,
	"./Slovakia.png": 84362,
	"./Slovenia.png": 52303,
	"./Soloman_Islands.png": 7512,
	"./Somalia.png": 56690,
	"./South_Africa.png": 3334,
	"./South_Georgia.png": 29998,
	"./South_Korea.png": 89388,
	"./Soviet_Union.png": 68532,
	"./Spain.png": 38647,
	"./Sri_Lanka.png": 63896,
	"./Sudan.png": 78873,
	"./Suriname.png": 55636,
	"./Swaziland.png": 18631,
	"./Sweden.png": 12970,
	"./Switzerland.png": 56527,
	"./Syria.png": 9192,
	"./Taiwan.png": 30842,
	"./Tajikistan.png": 64840,
	"./Tanzania.png": 41824,
	"./Thailand.png": 60935,
	"./Tibet.png": 21006,
	"./Timor-Leste.png": 35775,
	"./Togo.png": 55715,
	"./Tonga.png": 40979,
	"./Trinidad_and_Tobago.png": 49198,
	"./Tunisia.png": 33011,
	"./Turkey.png": 11616,
	"./Turkmenistan.png": 44871,
	"./Turks_and_Caicos_Islands.png": 78439,
	"./Tuvalu.png": 11517,
	"./UAE.png": 619,
	"./US_Virgin_Islands.png": 65115,
	"./Uganda.png": 74966,
	"./Ukraine.png": 55923,
	"./United_Kingdom.png": 16585,
	"./United_States_of_America.png": 70793,
	"./Uruguay.png": 83956,
	"./Uzbekistan.png": 93960,
	"./Vanuatu.png": 28676,
	"./Vatican_City.png": 16664,
	"./Venezuela.png": 2769,
	"./Vietnam.png": 43904,
	"./Wallis_and_Futuna.png": 52552,
	"./Yemen.png": 94146,
	"./Zambia.png": 294,
	"./Zimbabwe.png": 12873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46436;